export default __webpack_public_path__ + "static/bentoSectionBg3-8ffdeaa24239e1035bdec2d94ce8b2de.webp";